export const urlMap = new Map<string, string>([
    ['http://localhost:3000', 'http://localhost:8081/auth'],
    ['https://staging-app.codinfo.bio', 'https://staging-auth.codinfo.bio/auth'],
])